export const defaultMatchingValue = () => {
    return {   
        left : [],
        right : [],
        answers : [],
        styles: {
            left_width: null,
            right_width: null
        }
    }
}

export const defaultMatchingRowValue = () => {
    return {
        title : '',
        styles : {},
        layers: []
    }
}